<template>

    <section>
        <div style="min-height: 660px;" class="html-content">
            <div v-if="data" v-html="data">

            </div>

            <div class="null-data df fdc jcc aic" v-else>
                <img src="@/assets/images/empty_data.png" alt="">
                <p>{{ $t('暂无资料') }}</p>
            </div>

        </div>
    </section>
</template>

<script>
export default {
    props: {
        data: {
            type: String, // 指定参数类型
            // required: true // 是否为必需参数
        },
    },
}
</script>



<style lang="scss" scoped>
.html-content {
    line-height: 1.8;

    ::v-deep() {
                table{
                    max-width: 100%;
                }
                // td {
                //     border: 1px solid;
                // }

                a {
                    color: #0000ee;
                    text-decoration: underline;
                }

                i {
                    font-style: italic;
                }

                strong {
                    font-weight: bold;
                }

                ol,
                ul {
                    margin-left: 24px;
                }

                img,
                video {
                    max-width: 100%;
                    height: auto;
                }
            }

    ::v-deep() {
        table {
            // td {
            //     border: 1px solid #666666;
            // }
        }
    }
}

.null-data {
    height: 576px;

    p {
        color: #777777;
        font-size: 14px;
        font-weight: 400;
        line-height: 24px;
        margin-top: 7px;
    }
}
</style>